import { sva } from "@agapi/ui/panda/css";

export const navbarMegamenuStyles = sva({
  slots: ['megaMenuColumn', 'megaMenuHeaderTitle', 'megaMenuLink', 'megaMenuMoreButton'],
  base: {
    megaMenuColumn: {
      gap: '0',
      pb: '5'
    },
    megaMenuHeaderTitle: {
      textStyle: 'h5',
      fontSize: 'md'
    },
    megaMenuLink: {
      fontSize: 'sm'
    },
    megaMenuMoreButton: {
      fontSize: 'sm',
      fontWeight: 'medium',
      justifyContent: 'flex-start'
    }
  }
});
